import { RefreshCcw } from 'lucide-react'
import { Button } from '@deepguide-ai/ui/button'

interface ErrorStatusProps {
  icon: React.ReactNode
  description: string
  onRetry: () => void
}

const ErrorStatus = ({ icon, description, onRetry }: ErrorStatusProps) => {
  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-4 p-4 text-center'>
      <div className='flex max-w-sm shrink-0 flex-col items-center text-center'>
        <div className='border-border mb-2 h-[42px] w-[42px] rounded-md border border-solid p-[9px]'>
          {icon}
        </div>
        <div className='text-muted-foreground text-sm leading-6'>
          {description || 'There was an error. Please try again.'}
        </div>
      </div>

      <Button onClick={onRetry} variant='outline' size='sm'>
        <RefreshCcw />
        Retry
      </Button>
    </div>
  )
}

export default ErrorStatus
